import { selectModals, useAppSelector } from 'BreetRedux';

import Child from './Child';

const DialogSetDeveloperIpAddresses = () => {
	const modals = useAppSelector(selectModals);

	const modal = modals.find((modalItem) => modalItem.id === 'editDeveloperIpAddress');

	const ipAddressData = modal?.metadata as { ipAddress?: string } | undefined;

	return (
		<Child
			ipAddress={ipAddressData?.ipAddress}
			label='Edit IP Address'
			cta='Save'
			accessCredentialsVerificationId='edit-ip-address'
		/>
	);
};

export default DialogSetDeveloperIpAddresses;
